import {
  Badge
} from 'react-bootstrap';

export default function PTextLabel(props) {
  if (props.visible === false)
    return ""
  
  if (props.description !== undefined) {
    return (
      <p className="mb-0">
        {props.label}: <b>{props.value}</b> <Badge bg="danger">{props.description}</Badge>
      </p>
    )
  } else {
    return (
      <p className="mb-0">
        {props.label}: <b>{props.value}</b>
      </p>
    )
  }

}
